import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  Card,
  GDSStyleObject,
  HeadingText,
  StackLayout,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import React, { useEffect } from 'react';
import COBQuestioner from '../../../assets/json/COB_QUESTIONER.json';
import { COB_LIBRARY_ASSET_KEYS } from '../../../types/cob-library.types';

export function SectionDivider(props: any) {
  const { nextButtonClicked, name } = props;
  // eslint-disable-next-line react/destructuring-assignment
  useEffect(() => {}, [nextButtonClicked]);
  const isBelow375 = useMediaQuery('(max-width:375px)');
  const isMin641 = useMediaQuery(queryHelpers.down(1279));

  return (
    <StackLayout
      horizontalAlignment="center"
      css={
        {
          backgroundColor: 'White',
          maxWidth: '476px',
          height: '638px',
          borderRadius: '9px',
        } as GDSStyleObject
      }
      data-testid="sectionDivider"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$none $none',
            marginTop: '0px',
          } as GDSStyleObject
        }
      >
        <Card.Flat
          backgroundImage={
            useStaticAsset(COB_LIBRARY_ASSET_KEYS.GOOD_WORK) as string
          }
          css={{
            maxWidth: '480px',
            height: 'auto',
            minHeight: '638px',
            border: '0px solid',
            alignItems: 'center',
            '@desktop': { width: '480px', height: '638px' },
            '@mobile': { width: '380px', height: '638px' },
          }}
        >
          <Card.Section>
            <StackLayout
              verticalAlignment="center"
              horizontalAlignment="center"
              spacing="$one"
              css={{
                '@desktop': { paddingTop: isMin641 ? '90px' : '70px' },
                '@mobile': {
                  height: isBelow375 ? '86vh' : '',
                  paddingTop: isBelow375 ? '60px' : '80px',
                },
              }}
            >
              <HeadingText
                size="xxl"
                level="1"
                css={{
                  paddingTop: isMin641 ? '70px' : '70px',
                }}
              >
                {COBQuestioner.COB.GOODWORK.TITLE}
              </HeadingText>
              <HeadingText level="2" size="md" css={{ textAlign: 'center' }}>
                {COBQuestioner.COB.GOODWORK.CONTENT}{' '}
                {`${name[0]} ` === undefined ? 'your ' : `${name[0]} `}
                {COBQuestioner.COB.GOODWORK.SUBCONTENT}
              </HeadingText>
            </StackLayout>
          </Card.Section>
        </Card.Flat>
      </Box>
    </StackLayout>
  );
}
